import React, { useState } from 'react'
import GoodsPopup from './GoodsPopup'
import { typeLabel } from '../../pages/BuyCards/cardOptionUtils'
import styles from './Cart.module.css'

const Goods = ({
  isFreeFirst,
  checked,
  remove,
  cartItem,
  toggleChecked,
  cardOptions,
  cart,
  setCart,
  setChecked,
  checkedList,
}) => {
  const [popupVisible, setPopupVisible] = useState(false)
  // 购物车条目自带目录图（picUrl），不再按 skuId join cardOptions
  const imageUrl = cartItem.picUrl
  // 免费首卡（服务端归零口径）：单价处展示「免费」+ 划线目录原价。
  // 判定由 CartPage 按**已勾选**集合统一算好逐行下传——那是提交给服务端的明细顺序，服务端即按该
  // 顺序归零首条；此处按整车判会让未勾选的行标免费、真正被归零的行标原价（见 freeFirstCardKeys）

  return (
    <div className={styles.goods}>
      <div className={checked ? styles.checked : styles['not-checked']} onClick={(e) => toggleChecked(cartItem)}>
        {checked && <img src={require('../../assets/images/buy_cards/check-circle.png')} alt="checked" />}
      </div>
      <img src={imageUrl} className={styles['cert-img']} alt="cert" />
      <div className={styles['goods-detail']}>
        <div className={styles.top}>
          <div className={styles['card-name']}>《{cartItem.title}》</div>
          <div className={styles['card-detail']} onClick={() => setPopupVisible(true)}>
            <div className={styles['card-types']}>
              {typeLabel(cartItem.type)}/{cartItem.ecardName}
            </div>
            <div className={styles.arrow}></div>
          </div>
        </div>
        <div className={styles.bottom}>
          {isFreeFirst ? (
            <div className={styles.price}>
              <span className={styles['free-label']}>免费</span>
              <span className={styles['price-original']}>¥{cartItem.price / 100}</span>
            </div>
          ) : (
            <div className={styles.price}>¥{cartItem.price / 100}</div>
          )}
          <img
            src={require('../../assets/images/cart/delete-icon.png')}
            className={styles.delete}
            alt="delete"
            onClick={() => remove(cartItem)}
          />
        </div>
      </div>
      <GoodsPopup
        setVisible={setPopupVisible}
        visible={popupVisible}
        imageUrl={imageUrl}
        cardOptions={cardOptions}
        cart={cart}
        setCart={setCart}
        cartItem={cartItem}
        setChecked={setChecked}
        checkedList={checkedList}
      />
    </div>
  )
}

export default Goods
